import { CreatePostDto, ListWithTotals, PostDto, PostFilter, UpdatePostDto } from '@sweatpals/shared';
import { AxiosInstance, AxiosResponse } from 'axios';

export class PostsService {
	private readonly baseRoute = 'posts';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async findAll(filter: PostFilter): Promise<AxiosResponse<ListWithTotals<PostDto>>> {
		return this.httpClient.get<ListWithTotals<PostDto>>(`${this.baseRoute}`, {
			params: filter,
		});
	}

	public async findById(id: string): Promise<AxiosResponse<PostDto>> {
		return this.httpClient.get<PostDto>(`${this.baseRoute}/${id}`);
	}

	public async findByAlias(alias: string): Promise<AxiosResponse<PostDto>> {
		return this.httpClient.get<PostDto>(`${this.baseRoute}/public/${alias}`);
	}

	public async update(id: string, body: UpdatePostDto): Promise<AxiosResponse<PostDto>> {
		return this.httpClient.post<PostDto>(`${this.baseRoute}/${id}`, body);
	}

	public async delete(id: string): Promise<AxiosResponse<void>> {
		return this.httpClient.delete<void>(`${this.baseRoute}/${id}`);
	}

	public async create(body: CreatePostDto): Promise<AxiosResponse<PostDto>> {
		return this.httpClient.post<PostDto>(`${this.baseRoute}`, body);
	}
}
